// import { createSelector } from '@reduxjs/toolkit';
// Models
import { RootState } from 'store';

export const selectNotifications = (state:RootState) => state.ui.notifications;
export const selectError = (state:RootState) => state.ui.error;
